module.exports = __webpack_public_path__ + "static/media/enter.2b332e59.svg";